fragment SplitContentSliderFragment on splitContentSlider_Entry {
  typeHandle
  appearance
  slides: splitContentSlides {
    ... on splitContentSlidesBlock_Entry {
      id
      image {
        ...CraftAssetFragment
      }
      overlayImage {
        url
      }
      heading
      body
      productAttributes {
        url
      }
    }
  }
}
